/**
 * Утилиты для форматирования дат/чисел с учётом текущего языка UI.
 *
 * Заменяют паттерн:
 *   date.toLocaleDateString(i18n.language === 'ky' ? 'ky-KG' : 'ru-RU', {...})
 * на:
 *   formatDate(date, i18n.language, {...})
 */

/** Маппинг короткого языка → полный BCP47-локаль для Intl.DateTimeFormat. */
export function toIntlLocale(lang: string): string {
  const norm = lang.split('-')[0].toLowerCase();
  switch (norm) {
    case 'ky':
      // В macOS/iOS локаль 'ky-KG' плохо поддерживается — падаем на ru-RU.
      return 'ru-RU';
    case 'en':
      return 'en-US';
    case 'ru':
    default:
      return 'ru-RU';
  }
}

/** Форматирует дату. Опции — стандартные для Intl.DateTimeFormatOptions. */
export function formatDate(
  date: Date | string,
  lang: string,
  options?: Intl.DateTimeFormatOptions
): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString(toIntlLocale(lang), options);
}

/** Форматирует число (для сумм / деревьев). */
export function formatNumber(num: number, lang: string): string {
  return num.toLocaleString(toIntlLocale(lang));
}
